module.exports = __webpack_public_path__ + "static/media/997206.badcbc23.png";